// import axiosInstance from "../../../../axiosInstance";

const checkRequired = (value) => {
  if (!value || (typeof value === 'string' && !value.trim())) {
    return 'Required';
  }
};

const removeUndefined = (arr) =>
  Object.keys(arr)
    .filter((key) => arr[key] !== undefined)
    .reduce((res, key) => {
      res[key] = arr[key];
      return res;
    }, {});

    const checkNameExists = async (name) => {
      // try {
      //   const response = await axiosInstance.get(`/api/stages/checkName/${name}`);
  
      //   if (response.status === 200 && response.data.exists) {
          // return 'Name is available';
      //   }
      // } catch (error) {
      //   return 'Name already exists';
      // }
    };

const validate = async ({ name, form_id, stage_type_id, target_category_id, approver_role_id }) => {
  let errors = {};

  errors = removeUndefined({
    name: checkRequired(name),
    form_id: checkRequired(form_id),
    stage_type_id: checkRequired(stage_type_id)
  });

  // Conditional validation for target_category_id
  // TODO: change ID to be submission string
  if (stage_type_id === 1 && !target_category_id) {
    errors = {
      ...errors,
      target_category_id: checkRequired(target_category_id)
    };
  }

  // Conditional validation for approver_role_id
  // TODO: change ID to be approval string
  if (stage_type_id === 3 && !approver_role_id) {
    errors = {
      ...errors,
      approver_role_id: checkRequired(approver_role_id)
    };
  }

  // if (stage_type_id === 'Submission' && !target_category_id) {
  //   errors.target_category_id = 'End-User Category is required';
  // }

  // // Conditional validation for approver_role_id
  // if (stage_type_id === 'Review' && !approver_role_id) {
  //   errors.approver_role_id = 'Approver Role is required';
  // }
  
  if (!errors.name) {
    const nameError = await checkNameExists(name);
    if (nameError) {
      errors.name = nameError;
    }
  }

  return errors;
};

export default validate;